/**
* A dataservice that provides information on the Actora platform
*/
export class AboutService {
  private resource: ng.resource.IResourceClass<ng.resource.IResource<any>>;

  constructor(private $resource: ng.resource.IResourceService) {
    this.resource = $resource('api/about');
  }

  /**
   * Returns detals about the actora application
   *
   * @returns an object that provides details about the Actora application
   */
  public getAppDetails() {
    return this.resource.get().$promise;
  }
}